module.exports = __webpack_public_path__ + "img/16.fe9b6050.svg";